import React from 'react'
import './BannerSupport.css'
import { Button } from "@material-ui/core"
import { useHistory } from 'react-router-dom'

function BannerSupport() {

    const history = useHistory();

    return (
        <div className='banner'>
            <div className='banner__info'>
                <h1>Bienvenido a Ahavá !</h1>
                <h5>
                    Estás en la pantalla de Soporte. 
                    Para ir a la pantalla de Inicio, da click en el botón 
                    de abajo.
                </h5>
                <Button onClick={() => history.push('./privacy')}
                        variant='outlined'>
                        Ir al Inicio</Button>
            </div>
        </div>
    )
}

export default BannerSupport
